import { Component } from '@angular/core';
import { AlertControllerService } from 'src/app/shared/services/alert-controller/alert-controller.service';
import { Router } from '@angular/router';
import { UserSessionService } from '../../shared/services/user-session/user-session.service';

@Component({
    selector: 'app-login-error-page',
    templateUrl: './login-error-page.component.html',
    standalone: true
})
export class LoginErrorPageComponent {
  constructor(
    private router: Router,
    private _alertCtrl: AlertControllerService,
    private _userSessionService: UserSessionService
  ) {
    if (this.router.currentNavigation().extras.state) {
      let data: any = this.router.currentNavigation().extras.state.data;
      this._alertCtrl
        .presentError(data.ErrorDescription, data.ErrorTitle)
        .subscribe(result => {
          if (result) {
            this._userSessionService.onLogout.emit();
          }
        });
    }
  }
}
